module.exports = __webpack_public_path__ + "static/media/close-hover.32d4733e.svg";